import { IOffsiteCampaign } from '../../entities/offsiteCampaign';
import { IAction, IState } from './UseOffsiteCampaignsListContext';

export type ActionTypes =
  | 'SET_CAMPAIGNS_INITIAL'
  | 'UPDATE_CAMPAIGN'
  | 'ADD_CAMPAIGN'
  | 'UNSAVED_CAMPAIGNS_CHANGES'
  | 'CLOSE_CLONE_MODAL'
  | 'OPEN_CLONE_MODAL'
  | 'SET_SITE_INITIAL';

export function OffsiteCampaignsListReducer(state: IState, action: IAction) {
  const { payload } = action;
  let newState: IState = null;

  switch (action.type) {
    case 'SET_CAMPAIGNS_INITIAL':
      newState = {
        ...state,
        originalCampaigns: payload.campaigns,
        campaigns: payload.campaigns,
      };
      break;
    case 'UNSAVED_CAMPAIGNS_CHANGES':
      newState = {
        ...state,
        originalCampaigns: JSON.parse(JSON.stringify(payload.campaigns)) as IOffsiteCampaign[],
        campaigns: payload.campaigns,
      };
      break;
    case 'UPDATE_CAMPAIGN':
      newState = {
        ...state,
        campaigns: state.campaigns.map(campaign => (campaign.id === payload.campaign.id ? payload.campaign : campaign)),
      };
      break;
    case 'ADD_CAMPAIGN':
      newState = {
        ...state,
        campaigns: [...state.campaigns, payload.campaign],
      };
      break;
    case 'CLOSE_CLONE_MODAL':
      newState = {
        ...state,
        showCloneModal: false,
      };
      break;
    case 'OPEN_CLONE_MODAL':
      newState = {
        ...state,
        showCloneModal: true,
        campaign: payload.campaign,
      };
      break;
    case 'SET_SITE_INITIAL':
      newState = {
        ...state,
        site: payload.site,
      };
      break;
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
  return newState;
}
